// // import React from 'react';
// // import { useNavigate } from 'react-router-dom';

// // const MyShortsListbyReporter = () => {
// //   const navigate = useNavigate();

// //   const styles = {
// //     container: {
// //       display: 'flex',
// //       flexDirection: 'column',
// //       alignItems: 'center',
// //       justifyContent: 'center',
// //       height: '85vh',
// //       textAlign: 'center',
// //       fontFamily: '"Inter", "Segoe UI", sans-serif',
// //       backgroundColor: '#ffffff',
// //       padding: '20px'
// //     },
// //     card: {
// //       maxWidth: '650px',
// //       padding: '40px',
// //       borderRadius: '20px',
// //       boxShadow: '0 15px 35px rgba(0,0,0,0.05)',
// //       border: '1px solid #f0f0f0'
// //     },
// //     iconWrapper: {
// //       fontSize: '70px',
// //       marginBottom: '15px',
// //       display: 'inline-block',
// //       animation: 'pulse 2s infinite'
// //     },
// //     badge: {
// //       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //       color: '#fff',
// //       padding: '6px 20px',
// //       borderRadius: '50px',
// //       fontSize: '0.8rem',
// //       fontWeight: 'bold',
// //       letterSpacing: '1.2px',
// //       marginBottom: '20px',
// //       display: 'inline-block'
// //     },
// //     heading: {
// //       fontSize: '2.4rem',
// //       fontWeight: '800',
// //       color: '#1a202c',
// //       marginBottom: '15px'
// //     },
// //     subHeading: {
// //       fontSize: '1.1rem',
// //       color: '#4a5568',
// //       lineHeight: '1.7',
// //       marginBottom: '30px'
// //     },
// //     progressBar: {
// //       width: '100%',
// //       height: '8px',
// //       backgroundColor: '#edf2f7',
// //       borderRadius: '10px',
// //       overflow: 'hidden',
// //       marginBottom: '10px'
// //     },
// //     progressFill: {
// //       width: '80%', // Yahan progress dikhayein
// //       height: '100%',
// //       backgroundColor: '#764ba2',
// //       borderRadius: '10px',
// //       animation: 'loading 2.5s infinite ease-in-out'
// //     },
// //     statusText: {
// //       fontSize: '0.85rem',
// //       color: '#a0aec0',
// //       fontWeight: '600'
// //     },
// //     button: {
// //       marginTop: '35px',
// //       padding: '12px 30px',
// //       fontSize: '1rem',
// //       fontWeight: '600',
// //       backgroundColor: '#1a202c',
// //       color: 'white',
// //       border: 'none',
// //       borderRadius: '8px',
// //       cursor: 'pointer',
// //       transition: 'all 0.3s ease'
// //     }
// //   };

// //   return (
// //     <div style={styles.container}>
// //       <style>
// //         {`
// //           @keyframes pulse {
// //             0% { transform: scale(1); }
// //             50% { transform: scale(1.05); opacity: 0.8; }
// //             100% { transform: scale(1); }
// //           }
// //           @keyframes loading {
// //             0% { transform: translateX(-100%); }
// //             100% { transform: translateX(200%); }
// //           }
// //         `}
// //       </style>

// //       <div style={styles.card}>
// //         <div style={styles.iconWrapper}>📱</div>
// //         <br />
// //         <div style={styles.badge}>MODULE UNDER DEVELOPMENT</div>
        
// //         <h1 style={styles.heading}>My Shorts Dashboard</h1>
        
        
// //         <div style={styles.progressBar}>
// //           <div style={styles.progressFill}></div>
// //         </div>
// //         <div style={styles.statusText}>Project Status: 40% Finalized (Testing Phase)</div>

// //         <button 
// //           style={styles.button} 
// //           onClick={() => navigate(-1)}
// //           onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
// //           onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
// //         >
// //           Return to Dashboard
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default MyShortsListbyReporter;


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom"; // Navigation ke liye
// import {
//   Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead,
//   TableRow, Paper, Button, Chip, IconButton, Pagination, CircularProgress, 
//   Tooltip, Card, CardContent
// } from "@mui/material";
// import { Edit, Delete, Visibility, ThumbUp, Add, VideoLibrary } from "@mui/icons-material";
// import { getMyShorts, deleteShort } from "../../../services/reporterService";

// const MyShortsList = () => {
//   const navigate = useNavigate();
//   const [shorts, setShorts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const fetchShorts = async () => {
//     setLoading(true);
//     try {
//       const res = await getMyShorts(page, 10);
//       setShorts(res.data || []);
//       setTotalPages(res.totalPages || 1);
//     } finally { setLoading(false); }
//   };

//   useEffect(() => { fetchShorts(); }, [page]);

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this short?")) {
//       await deleteShort(id);
//       fetchShorts();
//     }
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#f8f9fa", minHeight: "100vh" }}>
//       {/* Top Header Section */}
//       <Box sx={{ 
//         display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4,
//         flexWrap: 'wrap', gap: 2 
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <VideoLibrary sx={{ fontSize: 40, color: '#1976d2' }} />
//           <Box>
//             <Typography variant="h4" fontWeight="800" color="#1a237e">My Shorts</Typography>
//             <Typography variant="body2" color="text.secondary">Manage and track your video performance</Typography>
//           </Box>
//         </Box>

//         <Button 
//           variant="contained" 
//           startIcon={<Add />}
//           onClick={() => navigate("/create-short")} // Aapka create page ka path
//           sx={{ 
//             borderRadius: 3, px: 3, py: 1.2, fontWeight: 'bold', textTransform: 'none',
//             boxShadow: '0 8px 20px rgba(25, 118, 210, 0.3)', fontSize: '1rem'
//           }}
//         >
//           Add New Short
//         </Button>
//       </Box>

//       {/* Content Section */}
//       {loading ? (
//         <Box display="flex" justifyContent="center" py={10}><CircularProgress /></Box>
//       ) : (
//         <TableContainer component={Paper} sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", border: '1px solid #eee' }}>
//           <Table>
//             <TableHead sx={{ bgcolor: "#f1f3f4" }}>
//               <TableRow>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Preview</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Video Details</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Status</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Engagement</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Upload Date</TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'bold', color: '#5f6368' }}>Actions</TableCell>
              
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {shorts.length === 0 ? (
//                 <TableRow><TableCell colSpan={6} align="center" sx={{ py: 8 }}>No shorts found. Click 'Add New Short' to start.</TableCell></TableRow>
//               ) : (
//                 shorts.map((row) => (
//                   <TableRow key={row._id} hover>
//                     <TableCell>
//                       <Box sx={{ position: "relative", width: 80, height: 110, borderRadius: 2, overflow: 'hidden', bgcolor: '#000' }}>
//                         <video src={row.videoUrl}  src={row.videoUrl}
//                         width="110"
//                         height="150"
//                         muted
//                         loop
//                         autoPlay
//                         style={{
//                           borderRadius: 8,
//                           objectFit: "cover",
//                         }}style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                       </Box>
//                     </TableCell>

//                     <TableCell sx={{ maxWidth: 250 }}>
//                       <Typography variant="subtitle1" fontWeight="bold" noWrap>{row.title}</Typography>
//                       <Typography variant="body2" color="text.secondary" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
//                         {row.description || "No description provided"}
//                       </Typography>
//                     </TableCell>

//                     <TableCell>
//                       <Chip 
//                         label={row.status} 
//                         size="small"
//                         sx={{ 
//                           fontWeight: "bold", textTransform: "capitalize",
//                           bgcolor: row.status === 'published' ? '#e8f5e9' : '#fff3e0',
//                           color: row.status === 'published' ? '#2e7d32' : '#ed6c02',
//                           borderRadius: 1.5
//                         }} 
//                       />
//                     </TableCell>

//                     <TableCell>
//                       <Box display="flex" gap={2}>
//                         {/* <Box display="flex" alignItems="center" gap={0.5} sx={{ color: '#5f6368' }}>
//                           <Visibility fontSize="small" />
//                           <Typography variant="caption" fontWeight="bold">{row.viewsCount || 0}</Typography>
//                         </Box> */}
//                         <Box display="flex" alignItems="center" gap={0.5} sx={{ color: '#5f6368' }}>
//                           <ThumbUp fontSize="small" />
//                           <Typography variant="caption" fontWeight="bold">{row.likes?.length || 0}</Typography>
//                         </Box>
//                       </Box>
//                     </TableCell>

//                     <TableCell>
//                       <Typography variant="body2" color="text.secondary">
//                         {new Date(row.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
//                       </Typography>
//                     </TableCell>
//                      <TableCell align="right">
//                       <Tooltip title="Edit">
//                         <IconButton size="small" sx={{ color: '#1976d2', bgcolor: '#e3f2fd', mr: 1, '&:hover': {bgcolor: '#bbdefb'} }}>
//                           <Edit fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Delete">
//                         <IconButton size="small" onClick={() => handleDelete(row._id)} sx={{ color: '#d32f2f', bgcolor: '#ffebee', '&:hover': {bgcolor: '#ffcdd2'} }}>
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>

//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}

//       <Box display="flex" justifyContent="center" mt={4}>
//         <Pagination count={totalPages} page={page} onChange={(e, v) => setPage(v)} color="primary" />
//       </Box>
//     </Box>
//   );
// };

// export default MyShortsList;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Button, Chip, IconButton, Pagination, CircularProgress,
  Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  MenuItem, Select, InputLabel, FormControl, Alert
} from "@mui/material";
import { Edit, Delete, ThumbUp, Add, VideoLibrary, CloudUpload } from "@mui/icons-material";
import { getMyShorts, deleteShort, updateShort } from "../../../services/reporterService";
import { getCategories } from "../../../services/apiService";

const MyShortsList = () => {
  const navigate = useNavigate();
  const [shorts, setShorts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ---- Edit dialog wala state ----
  const [editOpen, setEditOpen] = useState(false);
  const [editingShort, setEditingShort] = useState(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [videoFile, setVideoFile] = useState(null);

  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState("");
  const [categories, setCategories] = useState([]);

  // ---- Konsi row abhi update ho rahi hai, uska ID track karo ----
  const [updatingId, setUpdatingId] = useState(null);

  const fetchShorts = async () => {
    setLoading(true);
    try {
      const res = await getMyShorts(page, 10);
      setShorts(res.data || []);
      setTotalPages(res.totalPages || 1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShorts();
  }, [page]);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this short?")) {
      await deleteShort(id);
      fetchShorts();
    }
  };

  const handleEditOpen = (row) => {
    setEditingShort(row);
    setTitle(row.title || "");
    setDescription(row.description || "");
    setCategory(row.category?.name || row.category || "");
    setVideoFile(null);
    setEditError("");
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setEditingShort(null);
  };

  useEffect(() => {
    if (!editOpen) return;
    (async () => {
      try {
        const catRes = await getCategories();
        setCategories(catRes.data || []);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    })();
  }, [editOpen]);

  const handleUpdateSubmit = async () => {
    if (!title) {
      setEditError("Title is required.");
      return;
    }
    const idBeingUpdated = editingShort._id;
    setEditLoading(true);
    setUpdatingId(idBeingUpdated); // 👈 isi row pe spinner dikhane ke liye
    setEditError("");
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
      formData.append("category", category);
      if (videoFile) formData.append("video", videoFile); // sirf naya select hua to hi bhejo

      await updateShort(idBeingUpdated, formData);
      handleEditClose();
      await fetchShorts();
    } catch (error) {
      console.error("Failed to update short:", error);
      setEditError(error?.message || "Failed to update short.");
    } finally {
      setEditLoading(false);
      setUpdatingId(null);
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#f8f9fa", minHeight: "100vh" }}>
      {/* Top Header Section */}
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4,
        flexWrap: 'wrap', gap: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <VideoLibrary sx={{ fontSize: 40, color: '#1976d2' }} />
          <Box>
            <Typography variant="h4" fontWeight="800" color="#1a237e">My Shorts</Typography>
            <Typography variant="body2" color="text.secondary">Manage and track your video performance</Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate("/create-short")}
          sx={{
            borderRadius: 3, px: 3, py: 1.2, fontWeight: 'bold', textTransform: 'none',
            boxShadow: '0 8px 20px rgba(25, 118, 210, 0.3)', fontSize: '1rem'
          }}
        >
          Add New Short
        </Button>
      </Box>

      {/* Content Section */}
      {loading ? (
        <Box display="flex" justifyContent="center" py={10}><CircularProgress /></Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", border: '1px solid #eee' }}>
          <Table>
            <TableHead sx={{ bgcolor: "#f1f3f4" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Preview</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Video Details</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Engagement</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#5f6368' }}>Upload Date</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#5f6368' }}>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {shorts.length === 0 ? (
                <TableRow><TableCell colSpan={6} align="center" sx={{ py: 8 }}>No shorts found. Click 'Add New Short' to start.</TableCell></TableRow>
              ) : (
                shorts.map((row) => (
                  <TableRow key={row._id} hover>
                    <TableCell>
                      <Box sx={{ position: "relative", width: 80, height: 110, borderRadius: 2, overflow: 'hidden', bgcolor: '#000' }}>
                        <video
                          src={row.videoUrl}
                          width="110"
                          height="150"
                          muted
                          loop
                          autoPlay
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </Box>
                    </TableCell>

                    <TableCell sx={{ maxWidth: 250 }}>
                      <Typography variant="subtitle1" fontWeight="bold" noWrap>{row.title}</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {row.description || "No description provided"}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={row.status}
                        size="small"
                        sx={{
                          fontWeight: "bold", textTransform: "capitalize",
                          bgcolor: row.status === 'published' ? '#e8f5e9' : '#fff3e0',
                          color: row.status === 'published' ? '#2e7d32' : '#ed6c02',
                          borderRadius: 1.5
                        }}
                      />
                    </TableCell>

                    <TableCell>
                      <Box display="flex" gap={2}>
                        <Box display="flex" alignItems="center" gap={0.5} sx={{ color: '#5f6368' }}>
                          <ThumbUp fontSize="small" />
                          <Typography variant="caption" fontWeight="bold">{row.likes?.length || 0}</Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {new Date(row.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                      </Typography>
                    </TableCell>

                    <TableCell align="right">
                      <Tooltip title="Edit">
                        <span>
                          <IconButton
                            size="small"
                            disabled={updatingId === row._id}
                            onClick={() => handleEditOpen(row)}
                            sx={{ color: '#1976d2', bgcolor: '#e3f2fd', mr: 1, '&:hover': {bgcolor: '#bbdefb'} }}
                          >
                            {updatingId === row._id ? (
                              <CircularProgress size={16} sx={{ color: '#1976d2' }} />
                            ) : (
                              <Edit fontSize="small" />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                      {/* <Tooltip title="Delete">
                        <IconButton size="small" onClick={() => handleDelete(row._id)} sx={{ color: '#d32f2f', bgcolor: '#ffebee', '&:hover': {bgcolor: '#ffcdd2'} }}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip> */}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Box display="flex" justifyContent="center" mt={4}>
        <Pagination count={totalPages} page={page} onChange={(e, v) => setPage(v)} color="primary" />
      </Box>

      {/* ---- Edit Short Dialog ---- */}
      <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="sm">
        <DialogTitle>Edit Short</DialogTitle>
        <DialogContent dividers>
          {editError && <Alert severity="error" sx={{ mb: 2 }}>{editError}</Alert>}

          <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} fullWidth required sx={{ mb: 2, mt: 1 }} />
          <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={3} sx={{ mb: 2 }} />

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Category</InputLabel>
            <Select value={category} onChange={(e) => setCategory(e.target.value)}>
              {categories.map((c) => <MenuItem key={c._id} value={c.name}>{c.name}</MenuItem>)}
            </Select>
          </FormControl>

          {/* ---- Backend se aaya hua CURRENT video ka preview ---- */}
          <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
            Current Video
          </Typography>
          <Box sx={{ mb: 2, borderRadius: 2, overflow: 'hidden', bgcolor: '#000', width: 160, height: 220 }}>
            <video
              src={videoFile ? URL.createObjectURL(videoFile) : editingShort?.videoUrl}
              controls
              muted
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>

          <Box sx={{ border: "2px dashed #1976d2", borderRadius: 2, p: 2, textAlign: "center" }}>
            <input
              type="file"
              accept="video/*"
              id="edit-video-upload"
              style={{ display: "none" }}
              onChange={(e) => setVideoFile(e.target.files[0])}
            />
            <label htmlFor="edit-video-upload">
              <Button component="span" startIcon={<CloudUpload />} variant="outlined">
                {videoFile ? "Change Video" : "Replace Video (optional)"}
              </Button>
            </label>
            {videoFile ? (
              <Typography mt={1} variant="body2" color="text.secondary">Selected: {videoFile.name}</Typography>
            ) : (
              <Typography mt={1} variant="body2" color="text.secondary">Leave empty to keep the existing video.</Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} disabled={editLoading}>Cancel</Button>
          <Button onClick={handleUpdateSubmit} variant="contained" disabled={editLoading}>
            {editLoading ? <CircularProgress size={22} /> : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyShortsList;